import { useTranslation } from "react-i18next";

export default function DeclarationBanner() {
  const { t } = useTranslation();
  return (
    <section className="relative w-full min-h-[420px] md:min-h-[520px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20cinematic%20wide%20shot%20of%20international%20conference%20stage%20with%20warm%20crimson%20drapes%20and%20golden%20chandeliers%2C%20refined%20cream%20marble%20architecture%2C%20soft%20amber%20light%20haze%2C%20editorial%20photojournalism%20composition%20with%20subtle%20depth%20and%20ambience&width=1800&height=800&seq=iabs-declaration-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/85 via-primary-900/70 to-primary-950/60"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24 text-center w-full">
        <i className="ri-double-quotes-l w-12 h-12 flex items-center justify-center text-4xl md:text-5xl text-accent-400 mx-auto mb-6"></i>
        <h2 className="font-heading font-bold text-background-50 text-2xl md:text-4xl lg:text-5xl leading-relaxed max-w-4xl mx-auto">
          {t("declaration.quote")}
        </h2>
        <p className="text-background-100/80 text-sm md:text-base mt-6 tracking-wider">
          {t("declaration.attribution")}
        </p>
        <div className="mt-10 flex flex-wrap gap-4 justify-center">
          <a
            href="#"
            className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 hover:bg-accent-600 text-primary-950 rounded-md text-sm font-medium tracking-wider whitespace-nowrap cursor-pointer transition-colors"
          >
            {t("declaration.cta.read")}
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
          <a
            href="#"
            className="inline-flex items-center gap-2 px-6 py-3 border border-background-50/40 text-background-50 hover:bg-background-50/10 rounded-md text-sm font-medium tracking-wider whitespace-nowrap cursor-pointer transition-colors backdrop-blur"
          >
            {t("declaration.cta.download")}
            <i className="ri-download-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}